import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-app-download-modal',
  templateUrl: './app-download-modal.component.html',
  styleUrls: ['./app-download-modal.component.scss']
})
export class AppDownloadModalComponent implements OnInit {
  urls = {};
  version;
  constructor(private api:ApiService, public dialogRef: MatDialogRef<AppDownloadModalComponent>) { }

  ngOnInit(): void {
    this.identifyLinks();
  }

  identifyLinks(){
    // Get Browser Url Angular way
    if(environment.production){
      this.api.fetchLatestProdRelease().subscribe((res:any)=>{
        this.fillUrls(res);
      })
    }else{
      this.api.fetchLatestDevRelease().subscribe((res:any)=>{
        this.fillUrls(res);
      })
    }
  }

  fillUrls(res){
    res.assets.forEach((asset:any)=>{
      if(asset.name.endsWith('arm64.dmg')){
        this.urls["armdmg"] = asset.browser_download_url;
      }else
      if(asset.name.endsWith('.dmg')){
        this.urls["dmg"] = asset.browser_download_url;
      }else
      if (asset.name.endsWith('.exe')) {
        this.urls["exe"] = asset.browser_download_url;
      }
    })
  }

  download(url){
    window.open(this.urls[url], '_blank');
  }


  isMac(){
    return navigator.platform.toUpperCase().indexOf('MAC')>=0;
  }

  isWindows(){
    return navigator.platform.toUpperCase().indexOf('WIN')>=0;
  }



}
